import { iconNames } from '@zapier/design-system';

export const ICON_NAMES = Object.keys(iconNames).reduce((acc, key) => {
  return { ...acc, [key]: key };
}, {}) as { [key in keyof typeof iconNames]: key };
